/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable new-cap */
import React, { useContext, useState } from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Input,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ModalBody,
  Modal,
  ModalHeader,
} from "reactstrap";

// core components
import { useQuery } from "react-query";
import ApiContext from "services/ApiContext";
import ShopContext from "services/ShopContext";
import BasicTable from "views/tables/BasicTable";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./customerservice.css";
import moment from "moment";
import CurrencyFormat from "components/CurrencyFormat/CurrencyFormat";

import CustomButton from "components/CustomButton/CustomButton";
import CSPreviewOrder from "./CSPreviewOrder";
import CSInvoiceOrder from "./CSInvoiceOrder";
import CSImage from "./CSImage";
import AddCSImage from "./AddCSImage";
import SelfPickUpdateStatus from "./SelfPickUpdateStatus";

const ExampleCustomInput = React.forwardRef(
  // eslint-disable-next-line react/prop-types
  ({ value, children, onClick }, ref) => (
    <Input
      ref={ref}
      value={value}
      onClick={onClick}
      placeholder="Date Range for filter"
      className="h-100"
    >
      {children}
    </Input>
  )
);

function PickupOrder() {
  const shopID = useContext(ShopContext).selctShopID.ID;
  const Axios = useContext(ApiContext);

  const [searchQuery, setSearchQuery] = React.useState("");
  const [dateRange, setDateRange] = React.useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [filterDataResult, setFilterDataResult] = React.useState([]);

  const [dropItemList, setDropItemList] = React.useState({
    orderSource: [],
    status: [],
  });

  const [dropFilter, setDropFilter] = React.useState({
    orderSource: "Order Source",
    status: "Status",
  });

  const [dropOpen, setDropOpen] = React.useState("");

  const dropDownOptionGet = (data, id) => {
    const set = new Set();
    data.data.Result.forEach((row) => {
      if (row[id] !== "") set.add(row[id]);
    });
    return [...set.values()];
  };
  const { isLoading, data, isSuccess, refetch } = useQuery(
    `/shop/${shopID}/Order/CS/pickup`,
    async () =>
      shopID !== "0" &&
      Axios.get(`/shop/${shopID}/Order/CS`, {
        params: {
          limitPerPage: "100",
          DeliveryType: "Self-Pickup",
        },
      }).then((res) => {
        setDropItemList({
          orderSource: dropDownOptionGet(res, "OrderSource"),
          status: dropDownOptionGet(res, "ShopOrderStatus"),
        });
        const reversedData = res.data.Result.reverse();
        setFilterDataResult(reversedData);
        return res;
      }),
    { refetchOnWindowFocus: false }
  );

  const columns = [
    {
      name: "Order&Invoice No",
      selector: (row) => (
        <div className="m-2">
          <p>{`#${row.ID}`}</p>
          <p>{row.Invoice}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "DateTime",
      selector: (row) => (
        <div>
          <p>{moment(row.OrderDate).format("DD/MM/YYYY")}</p>
          {moment(row.OrderDate).format("hh:mm A")}
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Order Source",
      selector: (row) => row.OrderSource,
      sortable: true,
      wrap: true,
    },
    {
      name: "Name",
      selector: (row) => row.Name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Contact No",
      selector: (row) => row.Contact,
      sortable: true,
      wrap: true,
    },
    {
      name: "Amount",
      selector: (row) => (
        <div>
          <CurrencyFormat
            decimal={2}
            price={row.TotalOrderCost.toFixed(2)}
            currency="MYR"
          />
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Logistic",
      selector: (row) => row.DeliveryType,
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <div>
          {row.ShopOrderStatus === "Completed-Logistic" ? (
            <div>
              {row.ShopOrderStatus}
              <SelfPickUpdateStatus orderID={row.ID} refetch={refetch} />
            </div>
          ) : (
            row.ShopOrderStatus
          )}
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      selector: (row) => {
        const [previewModal, setPreviewModal] = useState({
          orderID: "",
          open: false,
        });
        const [invoiceModal, setInvoiceModal] = useState({
          orderID: "",
          open: false,
        });
        const [imageModal, setImageModal] = useState({
          imageList: [],
          open: false,
        });
        const [showModal, setShowModal] = useState({
          orderID: "",
          open: false,
        });
        if (!row) return null;

        return (
          <div>
            <CustomButton
              onClick={() =>
                setPreviewModal({
                  orderID: row.ID,
                  open: !previewModal.open,
                })
              }
              icon="fa fa-eye"
              title="View"
            />

            <CustomButton
              onClick={() =>
                setInvoiceModal({
                  orderID: row.ID,
                  open: !invoiceModal.open,
                })
              }
              icon="fa fa-file-text"
              title="Invoice"
            />
            <CustomButton
              to={`/shopowner/customerservice/vieworderdetails/${row.ID}`}
              icon="fa fa-search-plus"
              title="Order Details"
            />
            {row.ShopOrderStatus === "Self Picked Up" ? (
              <p>
                <CustomButton
                  onClick={() =>
                    setShowModal({
                      orderID: row.ID,
                      open: !showModal.open,
                    })
                  }
                  icon=""
                  title=""
                  text="Add Photos"
                  color="btn-primary"
                  size="btn-sm"
                />
              </p>
            ) : null}
            {row.ShopOrderStatus === "Order Completed" ? (
              <>
                <CustomButton
                  onClick={() =>
                    setImageModal({
                      orderID: row.ID,
                      open: !imageModal.open,
                    })
                  }
                  icon="fa fa-picture-o"
                  title="Photos"
                />

                <i
                  className="fa fa-flag"
                  aria-hidden="true"
                  style={{ color: "red", fontSize: "15px" }}
                  title="Photos"
                />
              </>
            ) : null}
            {/* Modal for preview detail */}
            <Modal
              size="lg"
              isOpen={previewModal.open}
              toggle={() =>
                setPreviewModal({
                  ...previewModal,
                  open: !previewModal.open,
                })
              }
            >
              <div>
                <Button
                  className="btn btn-primary float-right mr-5"
                  style={{ fontSize: "12px" }}
                  size="sm"
                  onClick={() =>
                    setPreviewModal({
                      ...previewModal,
                      open: false,
                    })
                  }
                >
                  x
                </Button>
              </div>

              <ModalBody>
                <CSPreviewOrder
                  previewID={previewModal.orderID}
                  setPreviewModal={setPreviewModal}
                  previewModal={previewModal}
                />
              </ModalBody>
            </Modal>
            {/* End of Modal for preview detail */}
            {/* Modal for invoice detail */}
            <Modal
              size="xl"
              isOpen={invoiceModal.open}
              toggle={() =>
                setInvoiceModal({
                  ...invoiceModal,
                  open: !invoiceModal.open,
                })
              }
            >
              <div>
                <Button
                  className="btn btn-primary float-right mr-5"
                  style={{ fontSize: "12px" }}
                  size="sm"
                  onClick={() =>
                    setInvoiceModal({
                      ...invoiceModal,
                      open: false,
                    })
                  }
                >
                  x
                </Button>
              </div>

              <ModalBody>
                <CSInvoiceOrder invoiceID={invoiceModal.orderID} />
              </ModalBody>
            </Modal>
            {/* End of Modal for invoice details */}
            {/* Modal for View CS image */}
            <Modal
              size="md"
              isOpen={imageModal.open}
              toggle={() =>
                setImageModal({
                  ...imageModal,
                  open: !imageModal.open,
                })
              }
            >
              <div>
                <Button
                  className="btn btn-primary float-right mr-5"
                  style={{ fontSize: "12px" }}
                  size="sm"
                  onClick={() =>
                    setImageModal({
                      ...imageModal,
                      open: false,
                    })
                  }
                >
                  x
                </Button>
              </div>

              <ModalBody>
                <CSImage orderID={imageModal.orderID} />
              </ModalBody>
            </Modal>
            {/* End of Modal for view CS image */}
            {/* Modal for Add CS image */}
            <Modal
              size="lg"
              isOpen={showModal.open}
              toggle={() =>
                setShowModal({
                  ...showModal,
                  open: !showModal.open,
                })
              }
            >
              <ModalHeader>
                <Button
                  className="btn btn-primary float-right"
                  style={{ fontSize: "12px" }}
                  size="sm"
                  onClick={() =>
                    setShowModal({
                      ...showModal,
                      open: false,
                    })
                  }
                >
                  x
                </Button>
                Add Photos
              </ModalHeader>
              <ModalBody>
                <AddCSImage
                  pID={showModal.orderID}
                  setShowModal={setShowModal}
                  showModal={showModal}
                />
              </ModalBody>
            </Modal>
            {/* End of Modal for Add CS image */}
          </div>
        );
      },
      wrap: true,
    },
  ];

  const dropdownToggle = (filter) => {
    if (filter === dropOpen) {
      setDropOpen("");
    } else {
      setDropOpen(filter);
    }
  };

  const resetFilter = () => {
    setDateRange([null, null]);
    setDropFilter({
      orderSource: "Order Source",
      status: "Status",
    });
    setFilterDataResult(data.data.Result);
  };

  const filterData = () => {
    if (isSuccess) {
      const finalData = data.data.Result.filter((item) =>
        startDate !== null
          ? new Date(item.OrderDate) >=
            new Date(
              moment(startDate).set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
              })
            ).getTime()
          : item
      )
        .filter((item) =>
          endDate !== null
            ? new Date(item.OrderDate) <=
              new Date(
                moment(endDate).set({
                  hour: 23,
                  minute: 59,
                  second: 59,
                  millisecond: 999,
                })
              ).getTime()
            : item
        )
        .filter((item) =>
          dropFilter.orderSource !== "Order Source"
            ? item.OrderSource === dropFilter.orderSource
            : item
        )
        .filter((item) =>
          dropFilter.status !== "Status"
            ? item.ShopOrderStatus === dropFilter.status
            : item
        )
        .filter(
          (item) =>
            (item.Name &&
              item.Name.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (item.Invoice &&
              item.Invoice.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (item.ID &&
              item.ID.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      setFilterDataResult(finalData);
    }
  };

  if (isLoading) {
    return (
      <Col className="text-center" md="12">
        <div className="uil-reload-css reload-background mr-1 align-center">
          <div className="" />
        </div>
      </Col>
    );
  }
  return (
    <div className="content px-3 w-100" style={{ overflowX: "auto" }}>
      <Card className="card-dark" style={{ minWidth: "350px" }}>
        <CardHeader>
          <CardTitle tag="h4">Pick Up Orders</CardTitle>
        </CardHeader>
        <CardBody>
          <Row xs={1} sm={2} className="my-2">
            <Col>
              <div>Filter Date: </div>
              <div className="d-flex">
                <ReactDatePicker
                  calendarClassName="h-100"
                  wrapperClassName="w-100 "
                  isClearable
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  dateFormat="dd/MM/yyyy"
                  customInput={<ExampleCustomInput />}
                />
              </div>
            </Col>
            <Col className="mt-2 mt-sm-0">
              <div>Search: </div>
              <div className="d-flex">
                <Input
                  onChange={(e) => setSearchQuery(e.target.value)}
                  value={searchQuery}
                />
                <Button className="ml-1  my-0" onClick={() => filterData()}>
                  Search
                </Button>
              </div>
            </Col>
          </Row>
          <div className="d-flex align-items-center">
            <span className="mr-2" style={{ fontSize: "16px" }}>
              Filter:
            </span>
            <Dropdown
              isOpen={dropOpen === "OrderSource"}
              toggle={() => dropdownToggle("OrderSource")}
            >
              <DropdownToggle caret color="filter" outline>
                {dropFilter.orderSource}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  onClick={() => {
                    setDropFilter({
                      ...dropFilter,
                      orderSource: "Order Source",
                    });
                  }}
                >
                  -
                </DropdownItem>
                {dropItemList.orderSource.map((x) => (
                  <DropdownItem
                    onClick={() => {
                      setDropFilter({ ...dropFilter, orderSource: x });
                    }}
                  >
                    {x}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
            <Dropdown
              isOpen={dropOpen === "Status"}
              toggle={() => dropdownToggle("Status")}
            >
              <DropdownToggle caret color="filter" outline>
                {dropFilter.status}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  onClick={() => {
                    setDropFilter({
                      ...dropFilter,
                      status: "Status",
                    });
                  }}
                >
                  -
                </DropdownItem>
                {dropItemList.status.map((x) => (
                  <DropdownItem
                    onClick={() => {
                      setDropFilter({ ...dropFilter, status: x });
                    }}
                  >
                    {x}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
            <Button className="ml-1" onClick={() => filterData()}>
              Filter
            </Button>
            <Button
              className="ml-1"
              color="danger"
              onClick={() => resetFilter()}
            >
              Reset All Filter
            </Button>
          </div>

          {isSuccess && data && (
            <div id="" className="mt-5">
              <BasicTable
                pagination
                id=""
                subHeaderWrap
                progressPending={isLoading}
                data={filterDataResult}
                columns={columns || []}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
}

export default PickupOrder;
